import { Component, EventEmitter, Output } from '@angular/core';
import { first } from '../../../../../node_modules/rxjs/operators';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { OmnisearchModel } from '../../../../shared/models/search/omnisearch.model';
import { BodyStyleType } from '../../../../vehicle/models/enums/body-style-type.enum';
import { FuelType } from '../../../../vehicle/models/enums/fuel-type.enum';
import { RegistrationStatusType } from '../../../../vehicle/models/enums/registration-status-type.enum';
import { TonnageRatingType } from '../../../../vehicle/models/enums/tonnage-rating-type.enum';
import { VINType } from '../../../../vehicle/models/enums/v-i-n-type.enum';
import { VehicleType } from '../../../../vehicle/models/enums/vehicle-type.enum';
import { VehicleModel } from '../../../../vehicle/models/vehicle.model';
import { RegistrationType } from '../../../models/enums/registration-type.enum';
import { RegistrationUseType } from '../../../models/enums/registration-use-type.enum';
import { RegistrationModel } from '../../../models/registration.model';
import { TitleRegistrationService } from '../../../services/titleregistration.service';

@Component({
    selector: 'registration-search',
    templateUrl: './registration-search.html',
})
export class RegistrationSearchComponent extends BaseComponent {
    @Output() onVehicleSelected: EventEmitter<OmnisearchModel> = new EventEmitter<OmnisearchModel>();

    public bodyStyleTypes = new BodyStyleType().GetAll();
    public fuelTypes = new FuelType().GetAll();
    public hasSearched = false;
    public registration: RegistrationModel;
    public registrationSearchString: string;
    public registrationStatusTypes  = new RegistrationStatusType().GetAll();
    public registrationTypes = new RegistrationType().GetAll();
    public registrationUseTypes = new RegistrationUseType().GetAll();
    public tonnageRatingTypes = new TonnageRatingType().GetAll();
    public vehicle: VehicleModel;
    public vehicleTypes = new VehicleType().GetAll();
    public vinTypes = new VINType().GetAll();

    constructor(private titleRegistrationService: TitleRegistrationService) {
        super();
    }

    public ngOnInit() {}

    public onVehicleClicked(selectedVehicle: VehicleModel) {
        this.onVehicleSelected.emit(this.mapVehicleModelToOmnisearchModel(selectedVehicle));
    }

    public registrationSearchClicked = async (): Promise<void> => {
        let self = this;
        if (!Number.isInteger(+self.registrationSearchString) || !self.registrationSearchString) {
            return;
        }

        const result = await self.titleRegistrationService.getRegistrationByRegistrationNumber(+self.registrationSearchString).pipe(first()).toPromise();
        if (result) {
            self.registration = result;

            if (!!result.vehicleOwnershipPlate && !!result.vehicleOwnershipPlate.vehicleOwnership) {
                self.vehicle = result.vehicleOwnershipPlate.vehicleOwnership.vehicle;
            }
        }

        self.hasSearched = true;
    };

    public resetSearch() {
        this.registrationSearchString = null;
        this.hasSearched = false;
        this.registration = null;
        this.vehicle = null;
    }

    private mapVehicleModelToOmnisearchModel(genResult: VehicleModel) {
        const result = new OmnisearchModel();
        result.bodyStyleTypeDisplayValue = genResult.bodyStyleTypeDisplayValue;
        result.makeDisplayValue = genResult.makeDisplayValue;
        result.modelDisplayValue = genResult.modelDisplayValue;
        result.modelYear = genResult.modelYear;
        result.vehicleId = genResult.id;
        result.vehicleNumber = genResult.vehicleNumber;
        result.vin = genResult.vin;
        return result;
    }
}
